import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import navLogo from "../img/technicblue.png";
import userImg from "../images/user-img.png";
import MyContext from "../ContextApi/MyContext";  // Fixed import

export default function UserNavbar() {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(MyContext);  // Fixed: useContext directly
  const { user, logout } = context || {};  // Safe destructuring

  useEffect(() => {
    const handleNav = (e) => {
      if (window.innerWidth <= 768 && !isNavbarCollapsed) {
        const navbar = document.getElementById("navbarSupportedContent");
        if (navbar && !navbar.contains(e.target)) {
          setIsNavbarCollapsed(true);
        }
      }
    };

    document.body.addEventListener("click", handleNav);
    return () => {
      document.body.removeEventListener("click", handleNav);
    };
  }, [isNavbarCollapsed]);

  const handleNavbarToggle = () => {
    setIsNavbarCollapsed(!isNavbarCollapsed);
  };

  const closeNavbarOnItemClick = () => {
    if (window.innerWidth <= 768) {
      setIsNavbarCollapsed(true);
    }
  };

 const handleLogout = () => {
    if (logout) logout();
    closeNavbarOnItemClick();
    navigate("/", { replace: true });
};

  // Hide navbar on these admin routes
  const hiddenAdminRoutes = [
    "/admin/addblog",
    "/admin/allposts",
    "/admin/allcategory",
    "/admin/addcategory",
    "/admin/board",
    "/admin/demoUsers",
    "/admin/tickets",
  ];

  if (hiddenAdminRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <div>
      {/* Navbar Start */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light" id="navbarSupportedContent">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/" onClick={closeNavbarOnItemClick}>
            <img
              src={navLogo}
              style={{ maxWidth: "14rem", marginLeft: "5%" }}
              alt="school management software"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={handleNavbarToggle}
            aria-controls="navbarSupportedContent"
            aria-expanded={!isNavbarCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isNavbarCollapsed ? "" : "show"}`} id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto" style={{ maxWidth: "120%", marginRight: "3%" }}>
              <li className="nav-item">
                <Link
                  className={`nav-link text-dark`}
                  aria-current="page"
                  to="/"
                  style={{ fontSize: "1.1rem" }}
                  onClick={closeNavbarOnItemClick}
                >
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <div className="dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle text-dark"
                    style={{ fontSize: "17px" }}
                    data-bs-toggle="dropdown"
                  >
                    About
                  </Link>
                  <div className="dropdown-menu rounded services-dropdown">
                    <Link to="/about" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Who We Are
                    </Link>
                    <Link to="/team" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Our Team
                    </Link>
                    <Link to="/portfolio" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Our Portfolio
                    </Link>
                    <Link to="/faq-page" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      FAQ's
                    </Link>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <div className="dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle text-dark"
                    style={{ fontSize: "17px" }}
                    data-bs-toggle="dropdown"
                  >
                    Services
                  </Link>
                  <div className="dropdown-menu rounded services-dropdown mr-3 ml-4">
                    <Link to="/web-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Web Design & Development
                    </Link>
                    <Link to="/software-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Software Development
                    </Link>
                    <Link to="/mobile-app-development-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Mobile App Development
                    </Link>
                    <Link to="/seo-services" className="dropdown-item text-dark sub-item service-item" onClick={closeNavbarOnItemClick}>
                      SEO Services
                    </Link>
                    <Link to="/digital-marketing-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Digital Marketing
                    </Link>
                    <Link to="/graphics-designing-services" className="dropdown-item text-dark sub-item" onClick={closeNavbarOnItemClick}>
                      Graphics Designing
                    </Link>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <div className="dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle text-dark"
                    style={{ fontSize: "17px" }}
                    data-bs-toggle="dropdown"
                  >
                    Products
                  </Link>
                  <div className="dropdown-menu rounded mr-2">
                    <Link to="/school-management-system" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                      School Management System
                    </Link>
                    <Link to="/business-management-solutions" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                      Business Management Solution
                    </Link>
                    <Link to="/ecommerce-solutions" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                      Ecommerce Solutions
                    </Link>
                    <Link to="/restuarent-management-system" className="dropdown-item text-dark" onClick={closeNavbarOnItemClick}>
                      Point Of Sale
                    </Link>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link text-dark"
                  aria-current="page"
                  to="/industries"
                  style={{ fontSize: "1.1rem" }}
                  onClick={closeNavbarOnItemClick}
                >
                  Industries
                </Link>
              </li>

              {/* User profile image - FIXED accessibility */}
             <li className="nav-item dropdown ms-2">
    <div 
        className="nav-link dropdown-toggle p-0 d-flex align-items-center"
        style={{ 
            height: "42px", 
            width: "42px", 
            cursor: "pointer",
            borderRadius: "50%",
            overflow: "hidden",
            border: "2px solid #dee2e6",
            backgroundColor: "#f8f9fa"
        }}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title="Account"
    >
        <img
            src={userImg}
            className="img-fluid w-100 h-100 object-fit-cover"
            alt="User profile"
        />
    </div>

    <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ minWidth: "240px" }}>
        <li className="px-3 py-3 bg-light border-bottom">
            <h6 className="mb-1">{user?.name || "User"}</h6>
            <small className="text-muted d-block">{user?.email || "—"}</small>
            <small className="text-muted d-block">{user?.phoneno || "—"}</small>
        </li>
    
        <li>
            <button 
                className="dropdown-item py-2 text-danger"
                onClick={handleLogout}
            >
                <i className="fas fa-sign-out-alt me-2"></i>
                Log Out
            </button>
        </li>
    </ul>
</li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}